import { ForwardedRef, forwardRef, ReactElement } from 'react';
import { Input as AntInput, InputProps as AntInputProps, InputRef } from 'antd';
import cc from 'classcat';
import { createTestId } from 'utils/helpers/create-test-id';
import './index.less';

export type InputProps = AntInputProps & {
  label?: string;
};

export const Input = forwardRef(
  (
    { label, className, ...props }: InputProps,
    ref: ForwardedRef<InputRef>
  ): ReactElement => {
    return (
      <div className={cc(['x-input', className])} {...createTestId('x-input')}>
        {!!label && <div className="x-input__label">{label}</div>}
        <AntInput {...props} className={className} ref={ref} />
      </div>
    );
  }
);
